import axios from 'axios';
import config from './config';
import { getSupportedCurrencies as fetchCurrencies } from './currencyApi';



// Fetch user by ID (safe, no password hash/salt)
export const fetchUserById = async (id) => {
  const response = await axios.get(`${config.API_BASE_URL}/UsersApi/${id}`);
  return response.data;
};


// Fetch cities from backend
export const fetchCities = async () => {
  const response = await axios.get(`${config.API_BASE_URL}/cities`);
  return response.data;
};

const API_BASE_URL = `${config.API_BASE_URL}/Product`; // Use HTTPS for backend API
const ORDER_API_URL = `${config.API_BASE_URL}/EStore/CheckOut`;
// Send order to backend
export const sendOrder = async (orderPayload) => {
  const response = await axios.post(ORDER_API_URL, orderPayload);
  return response.data;
};

// Send PreOrderDineIn order to backend
export const sendPreOrderDineIn = async (orderPayload) => {
  return sendOrder({ ...orderPayload, isPreOrderDineIn: true });
};

export const fetchCategories = async (branchId) => {
  // Categories are still at /api/categories
  const url = branchId ? `${config.API_BASE_URL}/categories?branchId=${branchId}` : `${config.API_BASE_URL}/categories`;
  const response = await axios.get(url);
  return response.data;
};

// Export currency functions
export { fetchCurrencies };

// Update fetchProducts to include currency parameter
export const fetchProducts = async (branchId, currency = null) => {
  let url = branchId ? `${API_BASE_URL}?branchId=${branchId}` : `${API_BASE_URL}`;
  if (currency) {
    url += `${branchId ? '&' : '?'}currency=${currency}`;
  }
  const response = await axios.get(url);
  return response.data;
};

// Update fetchProductById to include currency
export const fetchProductById = async (id, currency = null) => {
  let url = `${API_BASE_URL}/${id}`;
  if (currency) {
    url += `?currency=${currency}`;
  }
  const response = await axios.get(url);
  return response.data;
};

export const editProduct = async (id, productData) => {
  const response = await axios.put(`${API_BASE_URL}/EditProduct/${id}`, productData);
  return response.data;
};

export const fetchRestaurantInfo = async () => {
  const response = await axios.get(`${config.API_BASE_URL}/RestaurantInfo`);
  return response.data;
};
